import { Line } from 'react-chartjs-2'
import { ChartProvider, PageHeader } from '../../share/Components'
import classes from "./ManagementDashboard.module.scss";
import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import DateFilter from './Items/DateFilter'
import { useEffect, useState } from 'react';
import { ReducerType } from '../../storeManager/ReducerType';
import { useSelector } from 'react-redux';
import { LoginInterface } from '../../Interfaces/LoginInterface';
import { RaytebRequests } from '../../_services';
import useFetch from '../../_services/fetch';
const PaymentsReport = () => {
  const [labels, setLabels] = useState<Array<string>>([]);
  const [values, setValues] = useState<Array<number>>([]);
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  );
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const dateFilter = useSelector<ReducerType, DateFilterViewModel>(
    (state) => state.reducerDateFilter
  );

  const { isLoading, reFetch } = useFetch<
    Array<ManagementDataPerDateViewModel<number>>,
    unknown,
    { to?: Date; from?: Date }
  >({
    request: RaytebRequests.Management_GetPaymentsCount_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      setLabels(data.map((item) => new Date(item.date).toShamsi()));
      setValues(data.map((item) => item.value));
    },
  });
  useEffect(() => {
    reFetch(null, {
      from: dateFilter?.from,
      to: dateFilter?.to,
    });
  }, [dateFilter]); // eslint-disable-line react-hooks/exhaustive-deps
  const data = {
    labels,
    datasets: [
      {
        label: "مبلغ دریافتی",
        data: values,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };
  return (
    <>
      <PageHeader title="داشبورد مدیریتی / مبلغ دریافتی" />
      <div className={classes["report-dashboard"]}>
        <div className={classes["filters"]}>
          <DateFilter />
        </div>
        <div className={classes["items"]}>
          <ChartProvider
            listChart={[
              CategoryScale,
              LinearScale,
              PointElement,
              LineElement,
              Title,
              Tooltip,
              Legend,
            ]}
          >
            <Line data={data} />
          </ChartProvider>
        </div>
      </div>
    </>
  );
};
export default PaymentsReport;
